import { useEffect, useState } from 'react';

import { getCountdownDate } from './getCountdownDate';
import { getCountdownTime } from './getCountdownTime';

const getInitialCountdown = (a: { offerUntil?: string; courseLaunchDate?: Date }) =>
  getCountdownTime(getCountdownDate(a));

// TODO get rid of "courseLaunchDate". Based on the logic it useless and can be easily replaced with more unified offerUntil
export function useCountdownTimer({
  courseLaunchDate,
  offerUntil,
  onFinish,
}: {
  courseLaunchDate?: Date; // @deprecated
  offerUntil?: string;
  onFinish?(): void;
}) {
  const [countdownTime, setCountdownTime] = useState(() =>
    getInitialCountdown({ offerUntil, courseLaunchDate }),
  );

  useEffect(() => {
    const futureDate = getCountdownDate({ offerUntil, courseLaunchDate });
    const intervalId = setInterval(() => {
      const clockTime = getCountdownTime(futureDate);
      if (clockTime.timeDifference <= 0 && onFinish) onFinish();
      setCountdownTime(clockTime);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [courseLaunchDate, offerUntil, onFinish]);

  return { countdownTime };
}
